import React from 'react';
import { Table, Button } from 'reactstrap';
import Row from '../Row';
import $ from 'jquery';
import DropZoneTable from './DropZoneTable';
import { connect } from 'react-redux'
import UpArrow from '@mui/icons-material/KeyboardArrowUp';
import DownArrow from '@mui/icons-material/KeyboardArrowDown';

class PollerServiceTable extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            currentPage: 0,
            numPages: 0,
            pageNumber: 1,
            prevPageLimit: 0,
            pageLimit: 10,
            rowsShown: 9,
            sortConfig: { key: null, direction: 'asc' },
            sortedLogs: null,
            filters: {
                name: '',
                documentType: '',
                folder: '',
                directoryOrAddress: '',
                state: '',
                datetime: ''                                
            },
            showFilters: false            
        }

        this.goToNextPage = this.goToNextPage.bind(this)
        this.goToPrevPage = this.goToPrevPage.bind(this)
    }

    componentDidUpdate(prevProps) {
        if (this.props.logs !== prevProps.logs) {
            let noPages = Math.ceil(this.props.logs.length / this.state.pageLimit)
            this.setState({
                numPages: noPages,
                currentPage: 0,
                sortedLogs: null
            })
        }
    }

    goToNextPage() {
        let page = this.state.currentPage + 1
        if (page < this.state.numPages)
            this.setState({
                currentPage: page
            })
    }

    goToPrevPage() {
        let page = this.state.currentPage - 1
        if (page >= 0)
            this.setState({
                currentPage: page
            })
    }

    handleFilterChange = (key, value) => {
    this.setState((prevState) => ({
        filters: {
            ...prevState.filters,
            [key]: value
        },
        currentPage: 0 // optional: reset to first page on filter
        }));
    };

    toggleFilters = () => {
        this.setState((prevState) => ({
            showFilters: !prevState.showFilters
        }));
    };

    clearAllFilters = () => {
        this.setState({
            filters: {
                name: '',
                documentType: '',
                folder: '',
                directoryOrAddress: '',
                state: '',
                datetime: ''
            },
            currentPage: 0 // optional: reset to first page
        });
    };

    onSort = (key) => {
        this.setState((prevState) => {
            const direction = prevState.sortConfig.key === key && prevState.sortConfig.direction === 'asc' ? 'desc' : 'asc';

            const logs = [...(prevState.sortedLogs || this.props.logs)];

            const sortedRows = [...logs].sort((a, b) => {
                let aValue = a[key];
                let bValue = b[key];

                // Fallback in case of undefined values
                if (aValue == null) aValue = '';
                if (bValue == null) bValue = '';

                if (typeof aValue === 'string') aValue = aValue.toLowerCase();
                if (typeof bValue === 'string') bValue = bValue.toLowerCase();

                if (aValue < bValue) return direction === 'asc' ? -1 : 1;
                if (aValue > bValue) return direction === 'asc' ? 1 : -1;
                return 0;
            });

            return {
                sortedLogs: sortedRows,
                sortConfig: { key, direction }
            };
        });
    };

    renderSortableFilterableHeader = (filterKey, onSort, labelKey, labelFallback) => {
      const isSorted = this.state.sortConfig.key === filterKey;
      const sortArrow = isSorted
      ? this.state.sortConfig.direction === 'asc'
        ? <UpArrow />
        : <DownArrow />
      : null;

      const label = this.getLocalizedLabel(labelKey, labelFallback);

      return (
      <th
        key={filterKey}
        className="s-grid-title-cell"
        style={{ cursor: 'pointer' }}
        onClick={() => this.onSort(onSort)}
      >
        <div className="s-grid-title-cell-filter">
          {label} {sortArrow}
        </div>
        <div>
          {this.state.showFilters && (
            <input
              className="form-control form-control-sm"
              type="text"
              placeholder="Start typing to search..."
              value={this.state.filters[filterKey] || ''}
              onMouseDown={(e) => e.stopPropagation()}
              onChange={(e) => this.handleFilterChange(filterKey, e.target.value)}
            />
          )}
        </div>
      </th>
      );
    };

    getLocalizedLabel = (key, fallback) => {
      const labelObj = this.props.userReducer.localisation[key];
      return labelObj?.element_lang || fallback;
    };


    render() {

        var b = true
        let grid_css = ''
        let id
        let rows = []
        let pageignation = <div />
        let is_checked = false;

        const { localisation } = this.props.userReducer;

        const filtersActive = Object.values(this.state.filters).some(
            val => val.trim() !== ''
        );

        let startItem = this.state.currentPage * this.state.rowsShown;

        let endItem = startItem + this.state.rowsShown;

        let logsToRender = (this.state.sortedLogs || this.props.logs).filter(file => {
            const { filters } = this.state;

            const matches = (field, value) =>
                field?.toString().toLowerCase().includes(value.toLowerCase());

            const extractDatePortion = (dateStr) => {
                if (!dateStr) return '';
                const date = new Date(dateStr);

                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
                const year = String(date.getFullYear()).slice(2); // Get last 2 digits of year

                return `${day}/${month}/${year}`; // e.g. "03/04/25"
            };


            const userInput = filters.datetime.trim();
            const matchDate = userInput
                ? extractDatePortion(file.datetime).includes(userInput)
                : true;

            const matchDirectoryOrAddress = this.props.type == 'mailbox' ? file.address : file.directory;

            return (
                matches(file.name, filters.name) &&
                matches(file.documentType, filters.documentType) &&
                matches(file.folder, filters.folder) &&
                matches(matchDirectoryOrAddress, filters.directoryOrAddress) &&
                matches(file.status, filters.state) &&
                matchDate
            );
        });

        if (logsToRender) {
            logsToRender.forEach((row, i) => {
                if (i < startItem || i > endItem)
                    return

                grid_css += b ? "s-grid-row" : " s-grid-row s-record-alt";
                b = !b

                id = "P" + row._id

                if (this.props.checkedlogs && this.props.checkedlogs.includes(row))
                is_checked = true
                else
                    is_checked = false

                id = "P" + row._id
                rows.push(<Row
                    pollerPopover
                    pollerType={this.props.type}
                    rightAlign={[6]}
                    viewPortfolio={false}
                    onRowClicked={this.props.onRowClicked}
                    is_checked={is_checked}
                    checked={this.props.checked}
                    i={i}
                    checkChange={this.props.checkChange}
                    refresh={this.props.refresh}
                    id={id}
                    fileid={row._id}
                    tr_css={grid_css}
                    filename={row.name}
                    filetype={row.documentType}
                    version={row.folder}
                    dated={row.datetime}
                    user={this.props.type == 'mailbox' ? row.host + ':' + row.port : row.directory}
                    state={row.status}
                    file={row}
                    pages={1}
                    columnConfig={this.props.columnConfig}
                />);

            });
        }

        if (this.props.logs) {
            pageignation = <div>
                <div class="s-array-topbar-right">
                    <label class="s-pager-range">{this.props.logs.length > 1 ? localisation['table_header_records'] ? this.props.logs.length + ' ' + localisation['table_header_records'].element_lang : '' : localisation['table_header_record'] ? this.props.logs.length + ' ' + localisation['table_header_record'].element_lang : ''}</label>
                    <label class="s-pager-range">|</label>
                    <label class="s-pager-size-label">Page {this.state.currentPage + 1} / {this.state.numPages}</label>
                    <div class="s-pager">
                        <a onClick={this.goToPrevPage} class="s-pager-link s-fonticon-btn s-btn-previous"></a>
                        <a onClick={this.goToNextPage} class="s-pager-link s-fonticon-btn s-btn-next"></a>
                    </div>
                    <a onClick={this.props.refresh} class="s-mn-list-btn s-pager-link s-fonticon-btn s-mn-link s-btn-refresh"></a>
                    <button
                        className="btn btn-sm btn-outline-secondary"
                        style={{ marginLeft: '10px' }}
                        onClick={this.toggleFilters}
                        title={this.state.showFilters ? 'Hide search filters' : 'Show search filters'}
                    >
                        <i className="fa fa-filter" aria-hidden="true"></i>
                        <span style={{ marginLeft: '5px' }}>
                        {this.state.showFilters ? 'Hide search Filters' : 'Show search Filters'}
                        </span>
                    </button>
                    {filtersActive && (
                        <button
                            className="btn btn-sm btn-outline-danger"
                            onClick={this.clearAllFilters}
                            title="Clear all filter fields"
                            style={{ marginLeft: '10px' }}
                        >
                            <i className="fa fa-times" aria-hidden="true" style={{ marginRight: '5px' }}></i>
                            Clear Filters
                        </button>
                    )}
                </div>
                <div class="s-array-topbar-left">
                    <a onClick={this.props.selectAll} class="s-mn-list-btn s-pager-link s-fonticon-btn s-mn-link s-btn-refresh"></a>
                </div>
            </div>
        }


        return (
            <div class="s-slot-row">
                {pageignation}
                <Table responsive={true} hover={true} className="s-grid-table-head">
                    <tr>
                        {this.props.columnConfig?.checkbox && (
                            <th className="s-grid-title-cell s-grid-title-cell-small">
                                <div className="s-grid-title-empty"></div>
                            </th>
                        )}
                        {this.props.columnConfig?.actions && (
                            <th className="s-grid-title-cell s-grid-title-cell-small">
                                <div className="s-grid-title-empty"></div>
                            </th>
                        )}
                        {/* filterKey, onSort, labelKey, labelFallback */}
                        {this.renderSortableFilterableHeader('name', 'name', "table_header_name", "Name")} 
                        {this.renderSortableFilterableHeader('documentType', 'documentType', "table_header_document_type", "Document Type")}
                        {this.renderSortableFilterableHeader('folder', 'folder', "table_header_folder", "Folder")}                        
                        {this.props.type == 'mailbox' ?

                            this.renderSortableFilterableHeader('address', 'address', "table_header_address", "Address")
                            :
                            this.renderSortableFilterableHeader('directoryOrAddress', 'directory', "table_header_directory", "Directory")
                        }
                        {this.renderSortableFilterableHeader('state', 'state', "table_header_state", "State")}
                        {this.renderSortableFilterableHeader('datetime', 'datetime', "table_header_date", "Date")}
                    </tr>
                </Table>
                <div class="s-grid-slot-body">
                    <DropZoneTable refresh={this.props.refresh} rows={rows} />
                </div>
            </div>
        );
    }
}

export default connect(state => state)(PollerServiceTable);
